import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/dashboard/').then(res => setStats(res.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0B5D1E] mx-auto mt-20"></div>;

  const cards = [
    { label: 'Total Members', value: stats?.total_members, color: 'bg-blue-500', icon: '👥' },
    { label: 'Active Members', value: stats?.active_members, color: 'bg-green-500', icon: '✅' },
    { label: 'Pending Approvals', value: stats?.pending_approvals, color: 'bg-yellow-500', icon: '⏳' },
    { label: 'Pending Payments', value: stats?.pending_payments, color: 'bg-amber-500', icon: '🧾' },
    { label: 'Revenue (This Year)', value: `₦${Number(stats?.revenue_this_year || 0).toLocaleString()}`, color: 'bg-purple-500', icon: '💰' },
    { label: 'Total Revenue', value: `₦${Number(stats?.total_revenue || 0).toLocaleString()}`, color: 'bg-indigo-500', icon: '📈' },
    { label: 'Pending MCPD', value: stats?.pending_mcpd, color: 'bg-orange-500', icon: '📜' },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Admin Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {cards.map((c, i) => (
          <div key={i} className="bg-white rounded-xl shadow-md border p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{c.label}</p>
                <p className="text-2xl font-bold text-gray-900 mt-1">{c.value}</p>
              </div>
              <div className={`${c.color} rounded-lg p-3 text-2xl text-white`}>
                {c.icon}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Members by Category */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-white rounded-xl shadow-md border p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Members by Category</h2>
          <div className="space-y-3">
            {Object.entries(stats?.members_by_category || {}).map(([cat, count]) => (
              <div key={cat} className="flex justify-between items-center">
                <span className="text-sm capitalize text-gray-700">{cat.replace('_', ' ')}</span>
                <div className="flex items-center space-x-3">
                  <div className="w-32 bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-[#0B5D1E] h-2 rounded-full"
                      style={{ width: `${(count / (stats?.total_members || 1)) * 100}%` }}
                    />
                  </div>
                  <span className="text-sm font-semibold w-8 text-right">{count}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-md border p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Recent Payments</h2>
          {(!stats?.recent_payments || stats.recent_payments.length === 0) ? (
            <p className="text-gray-500 text-sm">No recent payments.</p>
          ) : (
            <div className="space-y-3">
              {stats.recent_payments.slice(0, 5).map((p) => (
                <div key={p.id} className="flex justify-between items-center py-2 border-b last:border-0">
                  <div>
                    <p className="font-medium text-sm">{p.member_name}</p>
                    <p className="text-xs text-gray-500 capitalize">{p.payment_type?.replace('_', ' ')}</p>
                  </div>
                  <span className="font-semibold text-sm text-green-600">₦{Number(p.amount).toLocaleString()}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
